import { Marked } from '@ts-stack/markdown'
export const EventEmailBase = ({
  sender_name = '',
  sender_email = '',
  tracker_code = '',
  subject = '',
  header_img = '',
  header_img_click_url = '',
  footer_img = '',
  footer_img_click_url = '',
  body_img = '',
  body_img_click_url = '',
  has_header_img = false,
  has_footer_img = false,
  is_simple = '',
  body = '',
  body_design = null,
  editor_type = 'default',
  is_send_certificate = false,
}) => ({
  sender_name,
  sender_email,
  tracker_code,
  subject,
  header_img,
  header_img_click_url,
  footer_img,
  footer_img_click_url,
  body_img,
  body_img_click_url,
  has_header_img,
  has_footer_img,
  is_simple,
  body,
  body_design,
  editor_type,
  is_send_certificate,
})

export const EventEmailHydrate = ({ body, editor_type = 'default', body_design = null, ...fields }) => ({
  ...fields,
  editor_type,
  body_design,
  // Solo parsear markdown para el editor default; Unlayer ya trae HTML limpio
  body: editor_type === 'unlayer' ? body : Marked.parse(body),
})
